export class NovoAtendimento {
  descricaoInicial: string;
  telefoneSolicitante: string;
  nomeSolicitante: string;
  descricao: string;
  tipoGerado: number;
  documento: string;
  tipoDocumento: number;
  pessoaId: number;
}
